module.exports = __webpack_public_path__ + "static/media/3.3eff85fc.jpg";